export default __webpack_public_path__ + "static/brand_guide-c7c28e154f01952062128677e4f4d1d5.png";